<template>
  <div>
    <div class="loading-state-container" v-if="loadVideoState && loadVideoState.status === 'loading'">
      <div class="container">
        <PreloaderSection />
      </div>
    </div>
    <div class="content-container" v-if="loadVideoState && loadVideoState.status === 'success'">
      <Page>
        <ConfirmModal
          v-if="modal"
          :onClose="handleModal"
          :onConfirm="onDelete">
          <template v-slot:header-title>
            <h4>ยืนยันการลบ</h4>
          </template>
          <div>คุณยืนยันที่จะลบวิดีโอ {{getVideoName()}}</div>
        </ConfirmModal>
        <template v-slot:page-header>
          <div class="container">
            <div class="page-header">
              <router-link
                class="btn btn-action btn-action-back"
                :to="`/live`">
                <i class="fas fa-chevron-left" />
              </router-link>
              <div class="title-container">
                <div class="subtitle">แก้ไขวิดีโอถ่ายทอดสด</div>
                <div class="title">{{tempVideoName}}</div>
              </div>
              <div class="actions">
                <small
                  class="text-danger mr-3"
                  v-if="getServerError()">
                  {{getServerError()}}
                </small>
                <small
                  class="text-success font-weight-bold mr-3"
                  v-if="saveVideoState.status === 'saved'">
                  <i class="fa fa-check" /> บันทึกแล้ว
                </small>
                <span v-if="isSaving">
                  <i class="fa fa-spin fa-spinner mr-1" />
                  <small class="mr-2">
                    กำลังบันทึก
                  </small>
                </span>
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="disableButton"
                  @click.stop="onSubmit">
                  บันทึก
                </button>
                <Dropdown :alignment="'right'">
                  <template v-slot:dropdow-button>
                    <button
                      type="button"
                      class="btn btn-outline-dark btn-action m-0 ml-2">
                      <i class="fas fa-cog"></i>
                    </button>
                  </template>
                  <a
                    :href="getPreviewLink()"
                    target="_blank"
                    class="dropdown-item">ดูตัวอย่าง</a>
                  <div
                    class="dropdown-item"
                    @click.stop="handleModal">
                    ลบวิดีโอ
                  </div>
                </Dropdown>
              </div>
            </div>
          </div>
        </template>
        <div class="container">
          <Tab>
            <div
              class="tab-item"
              v-for="(tabItem, tabIndex) in tabMenu"
              :key="tabIndex"
              :class="{'active': selectedTabIndex === tabIndex }"
              @click.stop="selectedTab(tabIndex)">
              {{tabItem.value}}
            </div>
          </Tab>
          <div
            class="tab-item tab-item-general"
            v-if="selectedTabIndex === 0">
            <div class="section-container">
              <SectionLiveGeneral />
            </div>
          </div>
          <div class="tab-item tab-item-general" v-if="selectedTabIndex === 1">
            <div class="section-container">
              <SectionContentImage
                @update:image="(payload) => $store.dispatch('setCurrentVideo', payload)"
                :item="currentVideo" />
            </div>
          </div>
          <div class="tab=item tab-item-general" v-if="selectedTabIndex === 2">
              <SectionLiveVideo />
          </div>
        </div>
      </Page>
      <ErrorMessageVideoContainer
        v-if="loadVideoState && loadVideoState.status === 'error'"
        :error="loadVideoState.error"
        :redirectLink="'/videos'" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

import PreloaderSection from '@/components/PreloaderSection.vue';
import ErrorMessageVideoContainer from '@/video/ErrorMessageVideoContainer.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';
import dateFormetter from '@/utils/dateFormatter';
import errorFormatter from '@/utils/errorFormatter';
import Tab from '@/components/Tab.vue';
import Dropdown from '@/components/Dropdown.vue';
import Page from '@/layouts/Page.vue';
import SectionContentImage from '@/image/SectionContentImage.vue';
import SectionLiveGeneral from './SectionLiveGeneral.vue';
import SectionLiveVideo from './SectionLiveVideo.vue';

export default {
  mixins: [dateFormetter, errorFormatter],
  components: {
    Tab,
    Page,
    PreloaderSection,
    ErrorMessageVideoContainer,
    ConfirmModal,
    SectionLiveGeneral,
    Dropdown,
    SectionContentImage,
    SectionLiveVideo,
  },
  data() {
    return {
      tabMenu: [
        {
          key: 'general',
          value: 'ข้อมูลวิดีโอถ่ายทอดสด',
        },
        // {
        //   key: 'information',
        //   value: 'รายละเอียด',
        // },
        {
          key: 'contentImage',
          value: 'รูปปก',
        },
        {
          key: 'live',
          value: 'ถ่ายทอดสด',
        },
      ],
      selectedTabIndex: 0,
      gallery: null,
      modal: false,
      saveGalleryState: {
        isSaving: false,
        isSaved: false,
        error: null,
      },
      tempVideoName: '',
    };
  },
  async created() {
    this.load(this.liveId);
  },
  computed: {
    ...mapState({
      currentVideo: (state) => state.videoItem.currentVideo,
      loadVideoState: (state) => state.videoItem.loadVideoState,
      saveVideoState: (state) => state.videoItem.saveVideoState,
      currentGallery: (state) => state.gallery.currentGallery,
    }),
    liveId() {
      return this.$route.params.liveId;
    },
    haveErrorMessage() {
      return _.some(this.saveVideoState.error, (value) => value);
    },
    saveVideoStatus() {
      return this.saveVideoState.status;
    },
    isSaving() {
      return this.saveVideoState.status === 'saving';
    },
    disableButton() {
      return this.haveErrorMessage || this.isSaving;
    },
  },
  watch: {
    saveVideoStatus(value) {
      if (value !== 'loading') {
        this.tempVideoName = this.getVideoName();
      }
    },
  },
  methods: {
    async load(liveId) {
      await this.$store.dispatch('loadVideoByVideoId', liveId);
      this.tempVideoName = this.currentVideo.title;
    },
    async onSubmit() {
      await this.$store.dispatch('updateVideoByVideoId', { videoId: this.liveId, payload: this.currentVideo });
    },
    async onDelete() {
      await this.$store.dispatch('deleteVideo', this.liveId);
      this.$router.push('/live');
    },
    handleModal() {
      this.modal = !this.modal;
    },
    selectedTab(selectedTabIndex) {
      this.selectedTabIndex = selectedTabIndex;
    },
    getServerError() {
      return _.get(this.saveVideoState, 'error.serverError', null);
    },
    getVideoName() {
      return _.get(this.currentVideo, 'title', this.liveId);
    },
    getPreviewLink() {
      return _.get(this.currentVideo, 'previewUrl', null);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/section-container.scss';

.loading-state-container {
  margin-top: $spacer * 6;
}

</style>
